export const standardTransition = value => {
  return `transition: ${value} 0.2s linear`;
};
